import React, { useEffect, useState } from 'react';
import { Step } from '@mui/material';
import StepLabel from './StepLabel/StepLabel';
import { StyledStepper } from './ValuationStatusTracker.styles';
import { StepStatus, ValuationStatusTrackerProps } from './ValuationStatusTracker.types';

const ValuationStatusTracker = ({
  statusOptions,
  currentStatusId,
  onStatusChange,
  isLoading = false,
  disabled = false,
}: ValuationStatusTrackerProps) => {
  const [activeStep, setActiveStep] = useState(0);

  // Sync activeStep with currentStatusId prop
  useEffect(() => {
    if (currentStatusId) {
      const stepIndex = statusOptions.findIndex(option => option.id === currentStatusId);
      if (stepIndex !== -1) {
        setActiveStep(stepIndex);
      }
    }
  }, [currentStatusId, statusOptions]);

  const getStep = (index: number): StepStatus => {
    const isLastStep = index === statusOptions.length - 1;
    const isCurrentStep = activeStep === index;

    // If this is the last step and it's the current step, show as completed
    if (isLastStep && isCurrentStep) {
      return StepStatus.COMPLETED;
    }

    // Current active step (but not the last one)
    if (isCurrentStep) {
      return StepStatus.ACTIVE;
    }

    // Completed steps (before current step)
    if (activeStep > index) {
      return StepStatus.COMPLETED;
    }

    // All other steps are pending
    return StepStatus.PENDING;
  };

  const handleSelectStep = (index: number) => {
    if (disabled || isLoading) {
      return;
    }

    const selectedOption = statusOptions[index];
    if (selectedOption && onStatusChange) {
      onStatusChange(selectedOption.id);
    }
    setActiveStep(index);
  };

  return (
    <StyledStepper activeStep={activeStep} orientation="vertical">
      {statusOptions.map((option, index) => (
        <Step key={option.id}>
          <StepLabel
            label={option.label}
            step={getStep(index)}
            onClick={() => handleSelectStep(index)}
            isLoading={isLoading}
            disabled={disabled}
          />
        </Step>
      ))}
    </StyledStepper>
  );
};

export default ValuationStatusTracker;
